import CharmsInfoSchema from '../schema/CharmsInfoSchema';
import charmsInfoStore from '../store';
import { select } from 'satcheljs/lib/legacy';

export interface GetCalendarCharmsInfo {
    charmStore: CharmsInfoSchema;
}

export let getAllCharmKeywords = select({
    charmStore: () => charmsInfoStore,
})(function getAllCharmKeywords(state?: GetCalendarCharmsInfo): string[] {
    var store = state.charmStore;
    let keywordsToReturn: string[] = [];
    if (store == null || store.keywordsMap == null) {
        return keywordsToReturn;
    }

    let keywordKeys = store.keywordsMap.keys();
    for (var keyword of keywordKeys) {
        keywordsToReturn.push(keyword);
    }

    return keywordsToReturn;
});

export default getAllCharmKeywords;
